import Content from "./components/content";
import BaseModal from "..";

export const CONTRACT_VIEWED_KEY = 'nami_contract_viewed';

const WorkPublish = {
  show(data) {
    this.self = BaseModal.show({
      borderRadius: 24,
      zIndex: 2003,
      content: (
        <Content
          {...data}
          onClose={this.close}
        />
      ),
      wrapClassName: 'nw-base-modal model-task-delete',
      maskClassName: 'nami-work-detail-mask',
      afterClose: () => {
        data?.afterClose?.();
      },
    });
  },
  close() {
    if (this.self) {
      this.self.destroy();
      this.self = null
    }
  }
}

export default WorkPublish